// extracted by mini-css-extract-plugin
export default {"trigger":"userDropdown_trigger__sp75L","indicator":"userDropdown_indicator__kogj+","overlay":"userDropdown_overlay__3zOr4","menu":"userDropdown_menu__PSxqT"};